function withTrailingSlash(u) {
    var t = u.trim();
    if (!t) {
        return t;
    }
    return t.endsWith('/') ? t : t + '/';
}
function trimTrailingSlashUrl(u) {
    return u.replace(/\/+$/, '');
}
export var seasonPreviewMediaConfig = {
    catalogUrl: (typeof process !== 'undefined' &&
        process.env &&
        process.env.REACT_APP_MOLO_STYLE_CATALOG_URL) ||
        'https://static.molo.com/molo-style/indexes/catalog.json',
    staticBaseUrl: withTrailingSlash((typeof process !== 'undefined' &&
        process.env &&
        process.env.REACT_APP_CDN_IMAGE_BASE_URL) ||
        'https://static.molo.com/'),
    packsApiBaseUrl: withTrailingSlash((typeof process !== 'undefined' &&
        process.env &&
        process.env.REACT_APP_PACKS_API_BASE_URL) ||
        'https://assets.molo.com/'),
    imageQueryParam: (typeof process !== 'undefined' && process.env && process.env.REACT_APP_IMAGE_QUERY_PARAM) ||
        'profile',
    imageProfileLarge: (typeof process !== 'undefined' && process.env && process.env.REACT_APP_IMAGE_PROFILE_LARGE) ||
        'salesbookimage',
    imageQueryLargeRaw: typeof process !== 'undefined' && process.env ? process.env.REACT_APP_IMAGE_QUERY_LARGE : undefined,
    fallbackSeason: (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SEASON_PREVIEW_SEASON) ||
        'W26',
};
export function moloStyleShardUrl(shardKey) {
    return seasonPreviewMediaConfig.staticBaseUrl + String(shardKey || '').replace(/^\/+/, '');
}
export function packsSeasonCompactIndexUrl(seasonCode) {
    var base = trimTrailingSlashUrl(seasonPreviewMediaConfig.packsApiBaseUrl);
    var season = String(seasonCode || '').trim().toLowerCase();
    return base + '/' + encodeURIComponent(season) + '/index.json?format=compact';
}
//# sourceMappingURL=mediaConfig.js.map